import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import { InjectedFormikProps, withFormik } from 'formik'

import Button        from '@material-ui/core/Button'
import Dialog        from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle   from '@material-ui/core/DialogTitle'

import { CoachingCertificate } from '../../api'
import { EnhancedTextField }   from '../atoms'
import {
  genValueMapper,
  mapFormikToMuiProps,
  proxyFormikSubmission,
}                              from './form-utils'
import coachingCertificateSchema, {
  emptyCoachingCertificate,
}                              from './schemas/coaching-certificate.schema'

interface AddCoachingExperienceDialogProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: (values: CoachingCertificate) => void
  close: () => void
}

type Props = InjectedFormikProps<AddCoachingExperienceDialogProps, CoachingCertificate>

const AddStudyDialog = (props: Props) => {
  const {
    isOpen,
    submitForm,
    close,
  } = props

  const mapper = mapFormikToMuiProps(props)

  return (
    <Dialog
      fullWidth
      open={isOpen}
    >
      <DialogTitle>
        <FormattedMessage id={'generic.addCoachingCertificate'} />
      </DialogTitle>
      <DialogContent>
        <EnhancedTextField
          {...mapper('name')}
          fullWidth
          margin={'dense'}
        />
        <EnhancedTextField
          {...mapper('grade')}
          fullWidth
          margin={'dense'}
        />
        <EnhancedTextField
          {...mapper('hours')}
          fullWidth
          type={'number'}
          margin={'dense'}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color={'primary'}
          onClick={close}
        >
          <FormattedMessage id={'buttonActions.cancel'} />
        </Button>
        <Button
          color={'primary'}
          onClick={submitForm}
        >
          <FormattedMessage id={'buttonActions.save'} />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default withFormik<AddCoachingExperienceDialogProps, CoachingCertificate>({
  validationSchema: coachingCertificateSchema,
  mapPropsToValues: genValueMapper(emptyCoachingCertificate),
  handleSubmit:     proxyFormikSubmission,
})(AddStudyDialog)



// WEBPACK FOOTER //
// ./src/components/forms/CoachingCertificateAddDialog.tsx